import React from "react";
import Modal from "./Modal"
import Default from "assets/images/default.png";
import Util from "pages/Dashboard/Common/Util";

const FilePreview = (props) => {   
  const {arr, handleDelete, disabled} = props;
  const [modalShow, setModalShow] = React.useState(false)
  const [selectedItem , setSelectedItem] = React.useState('')

  const modalOpen = (item) => {
    setSelectedItem(item)
    setModalShow(true)
  }

  const modalClose = () => {
    setModalShow(false);
  }

  return (
    <>
      <div style={{display:'flex', flexDirection:'row', width: 'calc(100% + 23px)', flexWrap : 'wrap', justifyContent:'flex-start'}}>
        {arr.length > 0 ? arr.map((image, index) => {
          let item = {
            path : image?.path,
            // path : Util.addHostUrl(image?.path),
            name : image?.name || ''
          }            
          return (
          <div key={'file_preview_'+index} style={{ width: "fit-content", position: "relative", gap: 24}}>
            <div style={{width: 109, height: 109, position: 'relative'}}>
              <img style={{ width: 109, height: 109, borderRadius: 4, border : '0.1px solid #bdbdbd', fontSize: 16 }} src={item.path} onError={(e) => e.target.src = Default} />
              { !disabled && 
                <p style={{ 
                    position: "absolute",
                    lineHeight: 0.5 , 
                    padding: 9, 
                    top: 5, 
                    right: 5, 
                    cursor: "pointer", 
                    borderRadius: 20, 
                    fontSize: 14, 
                    backgroundColor: 'rgba(77, 187, 170, 0.75)', 
                    width: 31, 
                    height: 31, 
                    color: '#fff',    
                    zIndex: 3
                  }}
                  onMouseEnter={(e)=>{e.target.style.background='rgba(77, 187, 170, 1)'}} 
                  onMouseLeave={(e)=>{e.target.style.background='rgba(77, 187, 170, 0.75)'}}
                  onClick={() => {
                    handleDelete(index)                    
                }}>
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.04125 6.50002L12.1235 11.5823L11.5828 12.1229L6.5006 7.04066L1.41836 12.1229L0.877718 11.5823L5.95995 6.50002L0.876953 1.41778L1.4176 0.877136L6.5006 5.95937L11.5828 0.877136L12.1235 1.41778L7.04125 6.50002Z" fill="white"/>
                  </svg>
                </p>
              }
              <div 
                onClick={() => {modalOpen(item)}}
                onMouseOver={(e)=>{e.target.style.background='none'}} 
                onMouseOut={(e)=>{e.target.style.background='rgba(0, 0, 0, 0.3)'}}
                style={{position:'absolute', backgroundColor: 'rgba(0, 0, 0, 0.3)', width: 109, height: 109, top:0, left: 0, zIndex: 2, cursor:'pointer'}}
              ></div>
            </div>
          </div>
        )}) : <></>
        }
      </div>
      <Modal title={'파일 미리보기'} show={modalShow} onHide={modalClose} size="md" onSubmit={()=>{}}>
        <div style={{ zIndex: 1, minHeight : '300px', width: '100%', display: "flex", justifyContent: "center", flexDirection: 'column' }}>
          <p style={{fontSize: '1rem', textAlign: 'center'}}>{selectedItem.name}</p>
          <img style={{
            margin: '0 auto',
            width: '90%',
          }}
          src={selectedItem?.path}
          onError={(e) => e.target.src = Default} />
        </div>
      </Modal>
    </>
  )

}

export default FilePreview;
